// ACTION TYPES
const name = 'params';
export const actionTypes = {
  SET_PARAM: `${name}:params`,
};

// ACTIONS
export function setParam(param) {
  return (dispatch) => {
    dispatch({ type: actionTypes.SET_PARAM, value: param });
  };
}
